import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/literature-monitoring")({
  head: () => buildRouteHead("/en/services/one-vigilance/literature-monitoring", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/literature-monitoring", replace: true });
  },
});
